
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.4 42.7c0 .6-.5 1.1-1.1 1.1H7.5c-.6 0-1.1-.5-1.1-1.1V7.3c0-.6.5-1.1 1.1-1.1h26.8c.6 0 1.1.5 1.1 1.1v4.6h2.5V7.3c0-2-1.6-3.6-3.6-3.6H7.5c-2 0-3.6 1.6-3.6 3.6v35.4c0 2 1.6 3.6 3.6 3.6h26.8c2 0 3.6-1.6 3.6-3.6V38h-2.5v4.7z"}}),_c('path',{attrs:{"d":"M36.3 35.6L46.9 25 36.3 14.4l-1.7 1.8 7.4 7.5H17.7v2.5h24.5l-7.6 7.6z"}})])
          )
        }
      }
    